
const ENUM = new Map([
  [
    'shopType', [
      { name: '总店', value: 1 },
      { name: '分店', value: 0 }
    ]
  ],
  [
    'platformType', [
      {
        name: '商户后台',
        value: 1
      }
      // {
      //   name: '扫码点单App',
      //   value: 2
      // },
      // {
      //   name: '码上餐厅App',
      //   value: 3
      // },
      // {
      //   name: '收音机App',
      //   value: 4
      // }
    ]
  ],
  [
    'shopModel', [
      {
        name: '直营',
        value: 1
      },
      {
        name: '加盟',
        value: 2
      },
      {
        name: '联营',
        value: 3
      }
    ]
  ]
])
export const getMapValue = (key, value) => {
  if (!ENUM.has(key)) {
    throw new Error(`在枚举值中 找不到${key}值`)
  }
  const arr = ENUM.get(key)
  const [data] = arr ? arr.filter(item => (`${item.value}` === `${value}`)) : []
  return data || {}
}
export const getMapItems = (key) => {
  if (!key) return

  if (!ENUM.has(key)) {
    throw new Error(`在枚举值中 找不到${key}值`)
  }
  // eslint-disable-next-line consistent-return
  return ENUM.get(key)
}
